class FeaturedCollectionsNav extends HTMLElement {
  constructor() {
    super();
    this.mainGrid = this.querySelector("[data-main-grid]");
    this.textLinks = this.querySelector("[data-text-links]");
    this.nestedTriggers = this.querySelectorAll("[data-nested-trigger]");
    this.nestedMenus = this.querySelectorAll("[data-nested-menu]");
    this.backButtons = this.querySelectorAll("[data-nested-back]");

    this.init();
  }

  init() {
    this.nestedTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const index = trigger.dataset.nestedIndex;
        this.showNestedMenu(index);
      });
    });

    this.backButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideNestedMenus();
      });
    });

    this.initInnerExpands();
  }

  initInnerExpands() {
    this.addEventListener("click", (e) => {
      const expandButton = e.target.closest("[data-inner-expand]");
      if (!expandButton) return;

      e.preventDefault();
      const nestedList = expandButton.parentElement.querySelector(
        "[data-inner-nested-list]"
      );

      if (!nestedList) return;

      const isExpanded = expandButton.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        const currentHeight = nestedList.offsetHeight;
        nestedList.style.height = currentHeight + "px";

        expandButton.setAttribute("aria-expanded", "false");
        nestedList.setAttribute("aria-hidden", "true");

        requestAnimationFrame(() => {
          nestedList.style.height = "0px";
        });
      } else {
        expandButton.setAttribute("aria-expanded", "true");
        nestedList.setAttribute("aria-hidden", "false");
        nestedList.style.height = "auto";
        const height = nestedList.offsetHeight;
        nestedList.style.height = "0px";

        requestAnimationFrame(() => {
          nestedList.style.height = height + "px";
        });
      }
    });
  }

  showNestedMenu(index) {
    const menu = this.querySelector(
      `[data-nested-menu][data-nested-index="${index}"]`
    );
    if (!menu) return;

    if (this.mainGrid) {
      this.mainGrid.setAttribute("data-hidden", "true");
    }

    if (this.textLinks) {
      this.textLinks.setAttribute("data-hidden", "true");
    }

    menu.setAttribute("aria-hidden", "false");

    menu.setAttribute("aria-hidden", "false");
  }
  hideNestedMenus() {
    this.nestedMenus.forEach((menu) => {
      menu.setAttribute("aria-hidden", "true");
    });

    if (this.mainGrid) {
      this.mainGrid.removeAttribute("data-hidden");
    }

    if (this.textLinks) {
      this.textLinks.removeAttribute("data-hidden");
    }
  }
}

if (!customElements.get("featured-collections-nav")) {
  customElements.define("featured-collections-nav", FeaturedCollectionsNav);
}

// Lazy-load the drawer upsell product cards. Their markup used to be
// server-rendered into the header on every page (~500KB of HTML before
// first paint); it now comes from the nav-mobile-upsells-lazy section
// via the Section Rendering API after the page has painted.
(function () {
  var slots = document.querySelectorAll("[data-lazy-upsell-slot]");
  if (!slots.length) return;
  var loaded = false;

  function loadUpsells() {
    if (loaded) return;
    loaded = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "?section_id=nav-mobile-upsells-lazy")
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        slots.forEach(function (slot) {
          var tpl = doc.querySelector(
            'template[data-lazy-upsell-for="' + slot.getAttribute("data-lazy-upsell-slot") + '"]'
          );
          if (tpl) slot.replaceWith(tpl.content.cloneNode(true));
        });
      })
      .catch(function () {
        loaded = false;
      });
  }

  // Load as soon as the menu is about to be used, or on idle as a fallback.
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest("[data-menu-button], [data-drawer-menu], .header__menu-icon")) loadUpsells();
    },
    { capture: true, passive: true }
  );
  if ("requestIdleCallback" in window) {
    requestIdleCallback(loadUpsells, { timeout: 5000 });
  } else {
    setTimeout(loadUpsells, 3000);
  }
})();
